import React from 'react';
import { PropTypes } from 'prop-types';
import { SmallInstructions } from '@styled';
import colors from '@general/colors';

const CharCounter = ({ max, count }) => {
    const color = count > max ? colors.error : null;

    return (
        <SmallInstructions color={color} style={{ textAlign: 'right', marginTop: '.5rem' }}>
            {count <= max && `${max - count} characters remaining of ${max}`}
            {count > max && `${Math.abs(max - count)} character over max ${max}`}
        </SmallInstructions>
    );
};

CharCounter.propTypes = {
    max: PropTypes.number,
    count: PropTypes.number,
};

export default CharCounter;
